export default {"src":"/_next/static/media/projectAccess.6df2b236.svg","height":107,"width":263,"blurWidth":0,"blurHeight":0};